import React, { createContext, FunctionComponent } from 'react'
import styled from 'styled-components'

export const SectionContext = createContext<{current: number}>({current: 0})

const Outer = styled.div`
  background-color: var(--background-color, #fcf3e7);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 4rem;
  @media (max-width: 40rem){
    padding-left: 0;
    padding-right: 0;
    
  }
`

type ContentContainerProps = {

}
export const ContentContainer: FunctionComponent<ContentContainerProps> = ({children}) => {
  const ref = {current: 0}
  return <Outer>
    <SectionContext.Provider value={ref}>
      {children}
    </SectionContext.Provider>
  </Outer>
}